import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Divider,
  Typography,
  TextField,
  Button,
  FormControl,
  FormHelperText,
  Card,
  Stack,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAction, SetNewPassword } from '../../Onboarding/auth/action';
import { trackUserLogout } from '../../../utils/clevertap';
import OTPInput from '../../Onboarding/Component/OtpInput';
import SendOtp from '../../Onboarding/Component/SendOtp';
import { SendOTPByPhoneNow } from '../APIs/action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptPassword } from '../../Utils/Encryption/NodeForgeEncryption';

const ChangePasswordCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });
  const phone_no = loginUser?.phone_no;

  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };
  const [OTPSent, setOTPSent] = useState(false);
  const handleOtpSend = async () => {
    if (!phone_no) return toast.error('Phone number is required');

    if (phone_no.length < 10) return toast.error('Enter a valid mobile number');

    const { data, message, error } = await SendOTPByPhoneNow(phone_no);
    if (!error) {
      toast.success('OTP sent successfully');
      setOTPSent(true);
    } else {
      toast.error(message);
    }
  };
  const onLogout = async () => {
    try {
      // Track logout in CleverTap before clearing data
      await trackUserLogout();
    } catch (error) {
      // Silent fail
    }
    
    await logoutAction();
    localStorage.clear();
    dispatch({ type: 'LOGOUT' });
    navigate('/login', { replace: true });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!phone_no) {
      return toast.error('Phone number is required');
    }
    if (!otp || otp.length < 4) {
      return toast.error('Enter a valid OTP');
    }

    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Confirm password is required';
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const payload = {
      otp: otp,
      password1: encryptPassword(password),
      password2: encryptPassword(confirmPassword),
      phone_number: encryptPassword(phone_no),
    };
    const { error, message } = await SetNewPassword(payload);
    if (!error) {
      toast.success('Password changed successfully, Please login again');
      return setTimeout(() => {
        onLogout();
      }, 1500);
    } else {
      return toast.error(message);
    }
  };

  return (
    <Accordion sx={{ borderRadius: 2, mt: 5 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ py: 1 }}
      >
        <Typography
          fontSize={'1rem'}
          fontWeight={'bold'}
          sx={{ pl: 2 }}
        >
          Change Password
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ m: '2rem' }}>
          <form onSubmit={handleSubmit}>
            <Stack
              direction={'row'}
              spacing={4}
              alignItems={'center'}
              sx={{ mt: 2 }}
            >
              <Typography variant='subtitle2'>Enter OTP</Typography>
              <OTPInput
                isDark={false}
                onOtpChange={handleOtpChange}
              />
              <Stack
                spacing={4}
                direction={'row-reverse'}
                alignItems={'center'}
                sx={{ mt: 2 }}
              >
                <SendOtp
                  OTPSent={OTPSent}
                  onResend={handleOtpSend}
                />
              </Stack>
            </Stack>
            <FormControl
              sx={{ width: '80%' }}
              margin='normal'
              error={!!errors.password}
            >
              <TextField
                fullWidth
                id='password'
                type='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                label='New Password'
              />
              {errors.password && (
                <FormHelperText>{errors.password}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              margin='normal'
              error={!!errors.confirmPassword}
              sx={{ width: '80%' }}
            >
              <TextField
                id='confirm-password'
                type='password'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                label='Confirm Password'
              />
              {errors.confirmPassword && (
                <FormHelperText>{errors.confirmPassword}</FormHelperText>
              )}
            </FormControl>
            <Box sx={{ mt: 2, width: '80%' }}>
              <Button
                type='submit'
                variant='outlined'
                color='primary'
                fullWidth
              >
                Reset Password
              </Button>
            </Box>
          </form>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default ChangePasswordCard;
